import SBLiveWordmark from 'icons/SBLiveWordmark';
import { ModalCloseButton } from '@/components/Modal';
import { useApplicationContainer } from 'containers/ApplicationContainer';
import styles from './styles/AuthModalHeader.module.scss';
import { getAuthModalTypeFromPath } from './AuthModalV2';

export default function AuthModalHeader({ title = 'Log in to your account' }: { title?: string }) {
  const [{ path }, { handleCloseAuthModal, handleOpenLink }] = useApplicationContainer();
  const formType = getAuthModalTypeFromPath(path);
  return (
    <div className={styles.HeaderContainer}>
      <div className={styles.HeaderTitle}>
        <SBLiveWordmark width={182} height={40} />
        <ModalCloseButton
          onClose={formType ? () => handleOpenLink('/') : handleCloseAuthModal}
          className={styles.CloseButton}
          width={17}
          height={17}
        />
      </div>
      <div className={styles.Tagline}>{title}</div>
      <div className={styles.Welcome}>Welcome back!</div>
    </div>
  );
}
